@if (isOpen) {
  <!-- Backdrop -->
  <div class="shift-panel-backdrop" (click)="onBackdropClick()"></div>

  <!-- Panel -->
  <div class="shift-panel">
    <!-- Header -->
    <div class="shift-panel-header">
      <div class="d-flex align-items-center gap-2">
        <i class="fa-solid fa-clock"></i>
        <span class="fw-semibold">My Shift</span>
      </div>
      <button class="btn-close-panel" (click)="close.emit()" aria-label="Close panel">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- Content -->
    <div class="shift-panel-body">
      @if (loading) {
        <div class="d-flex justify-content-center py-4">
          <div class="spinner-border spinner-border-sm text-light" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      } @else if (entries.length === 0 && !activeEntry) {
        <div class="empty-state">
          <i class="fa-regular fa-clock"></i>
          <p class="mb-0 mt-2">No entries today</p>
        </div>
      } @else {
        <!-- Today's Total -->
        <div class="total-section">
          <div class="total-label">Today's Total</div>
          <div class="total-value">{{ formatDuration(todayTotalHours) }}</div>
        </div>

        <!-- Active Clock-In -->
        @if (activeEntry) {
          <div class="active-entry">
            <div class="d-flex align-items-center gap-2 mb-1">
              <span class="active-dot"></span>
              <span class="entry-label">Clocked In</span>
            </div>
            @if (activeEntry.batch_number) {
              <div class="entry-detail">
                <i class="fa-solid fa-industry"></i>
                <span>{{ activeEntry.batch_number }}</span>
              </div>
            }
          </div>
        }

        <!-- Batches Worked On -->
        @if (batchGroups.length > 0) {
          <div class="section">
            <div class="section-title">
              <i class="fa-solid fa-layer-group"></i>
              Batches
            </div>
            @for (group of batchGroups; track group.batch_id) {
              <div class="entry-row">
                <span class="entry-name text-truncate">{{ group.batch_id }}</span>
                <span class="entry-hours">{{ formatDuration(group.total_hours) }}</span>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}
